export { getUserInfoServerAction } from 'next-flight-server-reference-proxy-loader?id=7fda480d1e442e90717492ce8ffb99fd420691d497&name=getUserInfoServerAction!'